import { Text } from '@thanx/uikit/text'
import { BrameCampaign } from 'api/brameCampaigns'
import { buildTranslate } from 'locales'
import React from 'react'
import { Button } from 'react-bootstrap'

const t = buildTranslate('games')

interface AddGameFormHeaderProps {
  editingGame?: BrameCampaign | null
  onCancel: () => void
}

const AddGameFormHeader: React.FC<AddGameFormHeaderProps> = ({
  editingGame,
  onCancel,
}) => {
  return (
    <div
      style={{
        backgroundColor: '#36424e',
        height: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        flexShrink: 0,
      }}
    >
      <Text.Header4 color="white">
        {editingGame
          ? t('addForm.header.editTitle')
          : t('addForm.header.title')}
      </Text.Header4>

      <div>
        <Button
          onClick={onCancel}
          className="btn-inverted"
          style={{
            padding: '14px 24px',
            fontSize: '16px',
            fontWeight: 'bold',
          }}
        >
          {t('addForm.header.exitButton')}
        </Button>
      </div>
    </div>
  )
}

export default AddGameFormHeader
